import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Modals.module.scss";
import {useTranslation} from "react-i18next";
import Images from "@/utils/images.ts";
import {InputAdornment, TextField} from "@mui/material";
import {strings} from "@/utils/strings.ts";
import {textfield_sx} from "@/utils/mui_sx.ts";
import {AlternateEmail} from "@mui/icons-material";
import Switcher from "@/ui/Switcher.tsx";
import Button from "@/ui/Button.tsx";

interface OfferNotifInterface {
    description: string
    default_check: boolean
}

const PromoSubscribe = () => {
    const [open, setOpen] = useState(false)
    const effect_ran = useRef<boolean>(false)
    const {t} = useTranslation()
    
    const openModal = (x:boolean) => {
        setOpen(x)
    }
    
    
    const offer_notif_types:Array<OfferNotifInterface> = [
        {
            description: t("promo_offer_type1"),
            default_check: true
        },
        
        {
            description: t("promo_offer_type2"),
            default_check: false
        },
        
        {
            description: t("promo_offer_type3"),
            default_check: false
        },
        
    ]
    
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.PromoSubscribe, openModal)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.ModalEvents.PromoSubscribe, openModal)
            }
        }
    }, []);
    
    return (
        <ModalLayout
            className={st.promo_subscribe}
            open={open}
            innerClassName={st.promo_subscribe_inner}
            on_close_state={() => {
                setOpen(false)
            }}
        >
            
            <>
                <div className={st.header}>
                    <img src={Images.common.promo_sketch} alt="promo_sketch" />
                    
                    <div className={st.overlayed}>
                        <p>{t("promo_subscribe")}</p>
                    </div>
                    
                </div>
                
                <form className={st.form}>
                    <TextField
                        name={"email"}
                        placeholder={strings["email_example"]}
                        color={"success"}
                        sx={textfield_sx}
                        label={t("email")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment sx={{ opacity: 1 }} position="end">
                                    <AlternateEmail />
                                </InputAdornment>
                            ),
                        }}
                        onFocus={() => {
                            eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, true)
                        }}
                        onBlur={() => {
                            eventEmitter.emit(CommonClass.ModalEvents.FocusInputs, false)
                        }}
                    />
                    
                    <div className={st.inputs}>
                        
                        <span className={st.inquire}>{t("prefered_promo_notif")}</span>
                        
                        {offer_notif_types.map((type:OfferNotifInterface, i:number) => {
                            
                            const {description, default_check} = type
                            
                            return (
                                <div className={st.notif_types} key={`offer_notif_types_${i}`}>
                                    <span>
                                        {description}
                                    </span>
                                    
                                    <Switcher  checked={default_check} />
                                </div>
                            )
                        })}
                        
                    </div>
                    
                    <Button animated >
                        <span>
                            {t("finish")}
                        </span>
                    </Button>
                </form>
            </>
        
        </ModalLayout>
    )
}

export default PromoSubscribe